// extracted by mini-css-extract-plugin
export default {"promoLink":"WsbNx","active":"_9tJG"};